import Vue from 'vue'
import { dataToOpts } from '@/utils/opts'
import { fetchList } from '@/api/setting/language'
import _ from 'lodash'

const query = {
  limit: 100,
  sort: 'id'
}

const dataToTransOpts = (data, t) => {
  if (!t || !t.$t) {
    return dataToOpts(data)
  }
  return dataToOpts(data, (e) => {
    const key = 'api.language.fields.options.map.' + e.code.replace('-', '')
    let name = e.name
    if (!t.$te || t.$te(key)) {
      name = t.$t(key)
    }
    return Object.assign({}, e, {
      name: name
    })
  })
}

const language = {
  state: {
    list: {},
    data: [],
    optData: {},
    filter: [],
    opencc: {},
    inited: false
  },

  mutations: {
    SET_OPENCC_TYPE: (state, data) => {
      Vue.set(state.opencc, data.lang, _.cloneDeep(data.type))
    },
    INIT_LANGUAGE: (state, e) => {
      state.inited = true
      state.data = _.cloneDeep(e.data)
      state.optData = dataToTransOpts(e.data, e.t)
      state.list = _.cloneDeep(state.optData.optsMap)
      state.optData.opts.forEach((opt) => {
        state.filter.push(
          {
            value: opt.id,
            text: opt.name
          }
        )
      })
    },
    RESET_LANGUAGE: (state, t) => {
      state.optData = dataToTransOpts(state.data, t)
      state.list = _.cloneDeep(state.optData.optsMap)
      state.filter.splice(0, state.filter.length)
      state.optData.opts.forEach((opt) => {
        state.filter.push(
          {
            value: opt.id,
            text: opt.name
          }
        )
      })
    }
  },

  actions: {
    SetOpenCCType ({ commit }, data) {
      commit('SET_OPENCC_TYPE', data)
    },
    InitLanguage ({ commit }, t) {
      if (this.state.language.inited) {
        return new Promise((resolve) => {
          resolve(this.state.language.optData)
        })
      }
      commit('SET_OPENCC_TYPE', {
        lang: 'zh-TW',
        type: ['s', 'twp']
      })
      commit('SET_OPENCC_TYPE', {
        lang: 'zh-CN',
        type: ['tw', 'sp']
      })
      return new Promise((resolve, reject) => {
        fetchList(query).then(res => {
          commit('INIT_LANGUAGE', {
            data: res.data,
            t: t
          })
          resolve(this.state.language.optData)
        }).catch(() => {
          // do nothing
        })
      })
    },
    ResetLanguage ({ commit }, t) {
      commit('RESET_LANGUAGE', t)
    }
  }
}

export default language
